import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type ObservationModel from './observation.ts';
import type ObservableDocumentModel from './observable-document.ts';

// Join between an observation and an observable document. Carries the per-document
// suppression state: when `discardedAt` is set, this document no longer backs the
// observation (see the API's Observation.undisputed scope).
export default class ObservationDocumentModel extends Model {
  @attr declare discardedAt: string | null;

  @belongsTo('observation', { async: false, inverse: null })
  declare observation: ObservationModel;

  @belongsTo('observable-document', { async: false, inverse: null })
  declare observableDocument: ObservableDocumentModel;

  get isSuppressed(): boolean {
    return Boolean(this.discardedAt);
  }

  [Type] = 'observation-document' as const;
}
